import apiClient from '../axiosInstance';
import { API_BASE_ADDRESS } from '../api';

const nicknameService = (action: any) => {
  const putNicknameData = {
    member_id: action.memberId,
    nickname: action.nickname,
  };

  return {
    putNickname: () => apiClient.put(`${API_BASE_ADDRESS}/mypage/member/nickname`, putNicknameData),
  };
};

export default nicknameService;
